import ShareModal from '@components/widgets/share-modal/share-modal';
export default ShareModal;
